import { render, staticRenderFns } from "./CardEditMobile.vue?vue&type=template&id=3270161d&"
import script from "./CardEditMobile.vue?vue&type=script&lang=js&"
export * from "./CardEditMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports